import React, { useState, useRef } from "react";
import "./Reunion_card_display.css";
import { Reunion_card, Underline } from "../../widgets";

const cardsPerRow = 5;

const Renioun_card_display = ({
  reunions2023 = [],
  reunions2024 = [],
  reunions2025 = []
}) => {
  const [rows, setRows] = useState(1);

  
  const scrollRefs = useRef({});
  
  const animationRefs = useRef({});

  const handleReadMore = (totalRows) => {
    setRows((prev) => Math.min(prev + 1, totalRows));
  };

  const handleReadLess = () => {
    setRows(1);
  };


  const startAutoScroll = (key) => {
    stopAutoScroll(key);

    const container = scrollRefs.current[key];
    if (!container) return;

    const step = () => {
      const maxScroll =
        container.scrollWidth - container.clientWidth;

      if (container.scrollLeft >= maxScroll) {
        // Pause at end, then restart
        setTimeout(() => {
          container.scrollLeft = 0;
          animationRefs.current[key] =
            requestAnimationFrame(step);
        }, 1500);
        return;
      }

      container.scrollLeft += 0.5; // smooth speed
      animationRefs.current[key] =
        requestAnimationFrame(step);
    };

    animationRefs.current[key] =
      requestAnimationFrame(step);
  };

  const stopAutoScroll = (key) => {
    if (animationRefs.current[key]) {
      cancelAnimationFrame(animationRefs.current[key]);
      delete animationRefs.current[key];
    }
  };

  const renderYear = (year, data) => {
    if (!data.length) return null;

    const totalRows = Math.ceil(data.length / cardsPerRow);

    return (
      <>
        <div className="heads">
          <Underline heading={year} />
        </div>

        {Array.from({ length: rows }).map((_, rowIndex) => {
          const start = rowIndex * cardsPerRow;
          const end = start + cardsPerRow;
          const scrollKey = `${year}-${rowIndex}`;

          return (
            <div
              key={scrollKey}
              className="horizontal_scroll_container_reunion"
              ref={(el) => {
                scrollRefs.current[scrollKey] = el;
                if (el) startAutoScroll(scrollKey);
              }}
              onMouseEnter={() => stopAutoScroll(scrollKey)}
              onMouseLeave={() => startAutoScroll(scrollKey)}
              onTouchStart={() => stopAutoScroll(scrollKey)}
              onTouchEnd={() => startAutoScroll(scrollKey)}
            >
              {data.slice(start, end).map((item, index) => (
                <div
                  className="horizontal_card_reunion"
                  key={index}
                >
                  <Reunion_card
                    cover={item.coverpic}
                    batch={item.batch}
                    name={item.name}
                    desc={item.desc}
                    date={item.date}
                  />
                </div>
              ))}
            </div>
          );
        })}

        {rows < totalRows && (
          <div
            className="read_more read_but"
            onClick={() => handleReadMore(totalRows)}
          >
            View More
          </div>
        )}

        {rows === totalRows && totalRows > 1 && (
          <div
            className="read_less read_but"
            onClick={handleReadLess}
          >
            View Less
          </div>
        )}
      </>
    );
  };

  return (
    <div className="reunion_display">     
      {renderYear("2025", reunions2025)}
      {renderYear("2024", reunions2024)}
      {renderYear("2023", reunions2023)}
    </div>
  );
};

export default Renioun_card_display;
